import { service } from '../default/default_service';

export enum Level {
  LOG = 'log',
  INFO = 'info',
  WARNING = 'warn',
  ERROR = 'error',
}

export function logToProductAnalytics(msg: string, level?: Level): void {
  service().captureLog(msg, level);
}
